module.exports = __webpack_public_path__ + "img/Leste.6676138e.svg";